import { notify } from 'utils/reduxUtils';

export const types = {
  OPEN_REVISION_DRAWER: 'quotes/OPEN_REVISION_DRAWER',
  CLOSE_REVISION_DRAWER: 'quotes/CLOSE_REVISION_DRAWER',
  GET_RELATED_REVISIONS_REQUEST: 'quotes/GET_RELATED_REVISIONS_REQUEST',
  GET_RELATED_REVISIONS_SUCCESS: 'quotes/GET_RELATED_REVISIONS_SUCCESS',
  GET_RELATED_REVISIONS_ERROR: 'quotes/GET_RELATED_REVISIONS_ERROR',
};

export const revisionDrawer = {
  open: () => ({
    type: types.OPEN_REVISION_DRAWER,
  }),
  close: () => ({
    type: types.CLOSE_REVISION_DRAWER,
  }),
};

export const getRelatedRevisions = {
  request: () => ({
    type: types.GET_RELATED_REVISIONS_REQUEST,
  }),

  success: ({ relatedRevisions }) => ({
    type: types.GET_RELATED_REVISIONS_SUCCESS,
    payload: { relatedRevisions },
  }),

  error: notify(
    (error) => ({
      type: types.GET_RELATED_REVISIONS_ERROR,
      payload: error,
    }),
    "Can't get quote revisions",
  ),
};
